/* ==========================================================================
   prinsert-shipping-bar.js
   --------------------------------------------------------------------------
   Zwei Aufgaben:

     1. Die Versandkosten-Fortschrittsleiste in die Warenkorb-Schublade
        einsetzen, direkt ueber den Gesamtkosten.
     2. Die Schublade nach dem Hinzufuegen kurz zeigen und von selbst wieder
        schliessen.

   ==========================================================================
   ALLE TEXTE KOMMEN AUS snippets/prinsert-shipping-bar.liquid (10.09.2026)

   JavaScript-Dateien werden von Shopify nicht durch Liquid geschickt; der
   t-Filter steht hier also nicht zur Verfuegung. Die Texte liegen deshalb
   als data-Attribute an #PrinsertShipData und stammen von dort aus den
   Sprachdateien.

   VORHER standen sie fest im Code -- mit der Folge, dass im englischen und
   franzoesischen Shop deutscher Text im Warenkorb stand.

   __BETRAG__ IST EIN PLATZHALTER: Der Restbetrag steht erst zur Laufzeit
   fest, kann also nicht in Liquid eingesetzt werden. Der uebersetzte Satz
   traegt die Marke, dieses Skript ersetzt sie. Wer den Sprachschluessel
   aendert, muss die Marke darin belassen.

   ZWEI ANZEIGEARTEN, gesteuert ueber data-mode:

     progress   Euro-Waehrung: Restbetrag und Balken
     static     andere Waehrung: fester Satz "Kostenloser Versand ab X EUR",
                kein Balken -- Liquid kann nicht umrechnen, ein Betrag in
                Landeswaehrung waere eine falsche Zusage

   ==========================================================================
   WARUM DER BALKEN LEER BLIEB (behoben, zwei getrennte Ursachen)

   ERSTENS, hier im Skript: Die erste Fassung hat die Leiste bei jedem
   Aufruf entfernt und neu angelegt -- mit Startbreite 0, danach animiert.
   Sobald zwei Aufrufe kurz nacheinander kamen (Kachel-Button ersetzt den
   Schubladen-Inhalt, kurz darauf meldet Dawn eine Aenderung), loeschte der
   zweite die Leiste, bevor die Animation des ersten begonnen hatte.
   JETZT: einmal aufbauen, danach nur noch Text und Breite aktualisieren.

   ZWEITENS, im CSS: Die Breite wurde korrekt gesetzt, der Balken blieb
   trotzdem unsichtbar -- seine Hoehe war 0, weil die spaeter geladenen
   Warenkorb-Stylesheets dazwischenfunkten. Siehe prinsert-product.css.
   ========================================================================== */

(function () {
  if (window.__prinsertShipBarInit) return;
  window.__prinsertShipBarInit = true;

  var OFFEN_MS = 5000;

  var schliessTimer = null;
  var nutzerAktiv = false;

  function daten() {
    var el = document.getElementById('PrinsertShipData');
    if (!el) return null;

    var schwelle = parseInt(el.getAttribute('data-threshold'), 10);
    if (!schwelle) return null;

    return {
      schwelle: schwelle,
      modus: el.getAttribute('data-mode') || 'progress',
      textFortschritt: el.getAttribute('data-text-progress') || '',
      textErreicht: el.getAttribute('data-text-done') || '',
      textStatisch: el.getAttribute('data-text-static') || ''
    };
  }

  function euro(cent) {
    return (cent / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function baueLeiste(footer, totals, mitBalken) {
    var bar = document.createElement('div');
    bar.className = 'prinsert-shipbar';
    bar.setAttribute('aria-live', 'polite');

    var text = document.createElement('p');
    text.className = 'prinsert-shipbar__text';
    bar.appendChild(text);

    /* Ohne Euro-Waehrung gibt es keinen Fortschritt zu zeigen -- die Spur
       bliebe eine leere graue Linie. Dann nur der Satz. */
    if (mitBalken) {
      var track = document.createElement('div');
      track.className = 'prinsert-shipbar__track';

      var fill = document.createElement('div');
      fill.className = 'prinsert-shipbar__fill';
      fill.style.width = '0%';

      track.appendChild(fill);
      bar.appendChild(track);

      /* Nur beim erstmaligen Einfuegen noetig: Das Element hat noch keinen
         gerenderten Zustand. Ohne diesen erzwungenen Layoutdurchlauf fasst
         der Browser "Breite 0" und "Breite X" zu einem Schritt zusammen und
         ueberspringt die Transition. */
      void fill.offsetWidth;
    }

    totals.parentNode.insertBefore(bar, totals);
    return bar;
  }

  function aktualisiereLeiste(summeCent) {
    var d = daten();
    if (!d) return;

    var footer = document.querySelector('.cart-drawer__footer');
    if (!footer) return;

    var totals = footer.querySelector('.totals');
    if (!totals) return;

    var mitBalken = d.modus === 'progress';

    /* Vorhandene Leiste weiterverwenden. Nur wenn sie fehlt -- weil die
       Schublade neu vom Server kam -- wird sie aufgebaut. */
    var bar = footer.querySelector('.prinsert-shipbar');
    if (!bar) {
      bar = baueLeiste(footer, totals, mitBalken);
    }

    var text = bar.querySelector('.prinsert-shipbar__text');
    if (!text) return;

    if (!mitBalken) {
      text.innerHTML = d.textStatisch;
      return;
    }

    if (isNaN(summeCent)) return;

    var fill = bar.querySelector('.prinsert-shipbar__fill');
    if (!fill) return;

    var fehlend = d.schwelle - summeCent;
    var erreicht = fehlend <= 0;
    var anteil = Math.max(0, Math.min(100, (summeCent / d.schwelle) * 100));

    bar.classList.toggle('is-complete', erreicht);

    if (erreicht) {
      text.innerHTML = d.textErreicht;
    } else {
      text.innerHTML = d.textFortschritt.replace('__BETRAG__', euro(fehlend) + '\u00a0\u20ac');
    }

    requestAnimationFrame(function () {
      fill.style.width = anteil + '%';
    });
  }

  function holeUndSetze(danach) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        aktualisiereLeiste(cart.total_price);
        if (typeof danach === 'function') danach(cart);
      })
      .catch(function () {});
  }

  function brichAbbrechen() {
    nutzerAktiv = true;
    clearTimeout(schliessTimer);
  }

  function zeigeWarenkorbKurz() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    nutzerAktiv = false;
    clearTimeout(schliessTimer);

    drawer.open();

    /* Nach dem Oeffnen noch einmal nachziehen: Erst jetzt ist die Schublade
       tatsaechlich sichtbar (Dawn setzt sie vorher auf visibility: hidden),
       und erst dann laeuft die Balkenanimation fuer den Kunden sichtbar ab. */
    setTimeout(function () {
      holeUndSetze();
    }, 60);

    schliessTimer = setTimeout(function () {
      if (nutzerAktiv) return;
      if (typeof drawer.close === 'function') drawer.close();
    }, OFFEN_MS);
  }

  function beobachteInteraktion() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__prinsertWatched) return;
    drawer.__prinsertWatched = true;

    /* Jede dieser Handlungen bedeutet: Der Kunde benutzt den Warenkorb.
       Dann bleibt er offen, bis er selbst schliesst. */
    ['mouseenter', 'click', 'touchstart', 'focusin', 'wheel'].forEach(function (ereignis) {
      drawer.addEventListener(ereignis, brichAbbrechen, { passive: true });
    });
  }

  function nachHinzufuegen() {
    holeUndSetze(function () {
      zeigeWarenkorbKurz();
      beobachteInteraktion();
    });
  }

  /* Vom Kachel-Button in prinsert-quick-cart.js */
  document.addEventListener('prinsert:cart-added', nachHinzufuegen);

  document.addEventListener('DOMContentLoaded', function () {
    beobachteInteraktion();

    /* Beim Seitenaufruf nur die Leiste setzen -- die Schublade bleibt zu. */
    if (document.getElementById('PrinsertShipData')) {
      holeUndSetze();
    }

    /* Dawn meldet Warenkorb-Aenderungen ueber PUB_SUB_EVENTS. Beim
       Hinzufuegen ueber das Produktformular oeffnen wir die Schublade,
       bei Mengenaenderungen im Warenkorb selbst nur die Leiste
       aktualisieren -- sonst poppt sie beim Aufraeumen auf. */
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') {
          nachHinzufuegen();
        } else {
          holeUndSetze();
        }
      });
    }
  });
})();
